



































import Vue, { PropType } from "vue"
import PHorizontalCardList from "./PHorizontalCardList.vue"
import PHorizontalCardListItem from "./PHorizontalCardListItem.vue"
import Container from "~/components/guideline/frame/Container.vue"
import { SimilarUserProfile } from "~/uiLogics/similarUserProfilesGetter"

export default Vue.extend({
  components: {
    Container,
    PHorizontalCardList,
    PHorizontalCardListItem,
  },
  props: {
    mainSmallJobCategoryName: {
      type: String,
      required: true,
    },
    similarUserProfiles: {
      type: Array as PropType<SimilarUserProfile[]>,
      required: true,
    },
  },
})
